import ReactDOM from 'react-dom';

import template from './confirm-leave-modal.html';
import { RenderWithWrapper } from '../../global/global.react';
import { ConfirmLeaveModal } from '../../modules/video-chat/confirm-leave-modal';
import { extensionIntegrEvents } from '../../modules/extensions-framework/angular-integration/integration-types';
import { EndCallReasons } from '../../common/services/doxy-analytics/tracks/video-session-end';
import { RootScopeEvents } from '../../common/services/root-scope-types';

export default angular
  .module('doxy.videoChat.confirm-leave-modal', [])
  .component('videoChatConfirmLeaveModal', {
    //video-chat-confirm-leave-modal
    template,
    bindings: {
      isInCall: '<',
      isPatient: '<',
    },
    controller: function (
      $scope,
      $rootScope,
      pn,
      trackingFactory,
      communicationControl
    ) {
      this.isSubscribed = false;
      const reactContainer = document.getElementById(
        'video-chat-confirm-leave-modal'
      );

      const unmount = () => {
        ReactDOM.unmountComponentAtNode(reactContainer);
      };

      this.endCallProvider = () => {
        $rootScope.$emit(
          extensionIntegrEvents.DOCTOR_ENDED_CALL,
          pn.globalState
        );

        $rootScope.$emit(
          'activeProvider:endReason',
          EndCallReasons.LEAVE_POPUP
        );
        communicationControl.removeEveryoneOnCall();
      };

      this.endCallPatient = () => {
        $rootScope.$emit(
          extensionIntegrEvents.PATIENT_ENDED_CALL,
          pn.globalState
        );

        $rootScope.$emit(
          'activeProvider:endReason',
          EndCallReasons.LEAVE_POPUP
        );
        communicationControl.phoneStop();
        $rootScope.$emit('removeCurrentPatientFromWaitingRoom');
      };

      this.endCall = () => {
        if (this.isPatient) {
          this.endCallPatient();
        } else {
          this.endCallProvider();
        }
      };

      this.openModal = (props) => {
        RenderWithWrapper(
          ConfirmLeaveModal,
          {
            onClose: () => unmount(),
            ...props,
          },
          reactContainer,
          $scope
        );
      };

      this.onChangeStartHandler = (event) => {
        event.preventDefault();
        $rootScope.$emit(RootScopeEvents.LEAVE_POPUP_COUNT);
        this.openModal({
          onLeave: () => {
            unsubscribe();
            this.endCall();
            unmount();
          },
        });
        return false;
      };

      this.deregisterLocationListener = () => {};
      this.deregisterStateListener = () => {};

      const subscribe = () => {
        if (this.isSubscribed || !this.isInCall) return;

        this.deregisterLocationListener = $rootScope.$on(
          '$locationChangeStart',
          this.onChangeStartHandler
        );

        this.deregisterStateListener = $rootScope.$on(
          '$stateChangeStart',
          this.onChangeStartHandler
        );

        this.isSubscribed = true;
      };

      const unsubscribe = () => {
        if (!this.isSubscribed) return;

        this.deregisterLocationListener();
        this.deregisterStateListener();

        this.isSubscribed = false;
      };

      this.$onChanges = (changes) => {
        if (changes.isInCall) {
          if (!changes.isInCall.currentValue) unmount();
          unsubscribe();
          subscribe();
        }
      };

      $scope.$on('$destroy', () => {
        unsubscribe();
      });
    },
  }).name;
